import { render, staticRenderFns } from "./refund_dialog.vue?vue&type=template&id=c22f169c&scoped=true&"
import script from "./refund_dialog.vue?vue&type=script&lang=js&"
export * from "./refund_dialog.vue?vue&type=script&lang=js&"
import style0 from "./refund_dialog.vue?vue&type=style&index=0&id=c22f169c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22f169c",
  null
  
)

export default component.exports